import { Alert, Stack } from '@mui/material';

type NoContentInfoProps = {
  readonly content: string | React.ReactNode;
};

export const NoContentInfo = (props: NoContentInfoProps) => (
  <Stack justifyContent="center" alignContent="center" padding={2} height="100%">
    <Stack direction="row" justifyContent="center">
      <Alert severity="info">{props.content}</Alert>
    </Stack>
  </Stack>
);
